import React from 'react'

interface IconProps {
  className?: string
}

const Logo = ({ className }: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_3122_44946)">
      <path
        d="M0 0V32H31.9983V0H0ZM26.8682 12.374H25.6675H15.9991C15.0387 12.374 14.1176 12.7556 13.4385 13.4348C12.7594 14.1139 12.3778 15.0351 12.3778 15.9957C12.3778 16.9562 12.7594 17.8774 13.4385 18.5566C14.1176 19.2358 15.0387 19.6174 15.9991 19.6174H22.0375V20.8494C22.0307 21.1661 21.9001 21.4676 21.6737 21.6892C21.4473 21.9107 21.1432 22.0348 20.8264 22.0347H15.9991C14.3977 22.0347 12.8618 21.3985 11.7293 20.2659C10.5969 19.1334 9.96075 17.5973 9.96075 15.9957C9.96075 14.394 10.5969 12.858 11.7293 11.7254C12.8618 10.5929 14.3977 9.95663 15.9991 9.95663H26.8682V12.374ZM26.8682 7.5289H25.7851C25.7453 7.5289 25.7055 7.53755 25.6606 7.53755H15.9991C13.7566 7.53755 11.6059 8.42849 10.0202 10.0144C8.4345 11.6002 7.54366 13.7512 7.54366 15.9939C7.54366 18.2367 8.4345 20.3876 10.0202 21.9735C11.6059 23.5594 13.7566 24.4503 15.9991 24.4503H20.8298C21.792 24.448 22.7139 24.0642 23.3935 23.383C24.073 22.7017 24.4546 21.7788 24.4546 20.8165V17.2069H15.9991C15.6779 17.2069 15.3699 17.0793 15.1427 16.8522C14.9156 16.625 14.788 16.3169 14.788 15.9957C14.788 15.6744 14.9156 15.3663 15.1427 15.1392C15.3699 14.912 15.6779 14.7844 15.9991 14.7844H26.8682V20.8234C26.8669 22.4244 26.2301 23.9593 25.0979 25.0909C23.9657 26.2226 22.4306 26.8586 20.8298 26.859H15.9991C13.1174 26.859 10.3537 25.7141 8.31597 23.6762C6.27826 21.6383 5.1335 18.8743 5.1335 15.9922C5.1335 13.1102 6.27826 10.3461 8.31597 8.30821C10.3537 6.27029 13.1174 5.1254 15.9991 5.1254H26.8682V7.5289Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3122_44946">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Logo
